import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { ButtonsWrapper } from '../../buttons/ButtonsWrapper';

interface Props {
  title: string;
  actions?: ReactNode;
}

const Container = styled(ButtonsWrapper)(({ theme }) => {
  const palette = (theme.vars || theme).palette;
  return {
    padding: theme.spacing(3),
    backgroundColor: palette.background.paper,
    borderBottom: `1px solid ${palette.divider}`,
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  };
});

export const ChatHeader = ({ title, actions }: Props) => (
  <Container>
    {/* Indented to line up with the message text inside the bubbles. On mobile the actions stack below, so it lines up with them instead */}
    <Typography variant="h6" sx={{ pl: { sm: 1 } }}>
      {title}
    </Typography>
    {actions}
  </Container>
);
